import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Form } from 'semantic-ui-react';
import { API, showSuccess } from '../helpers';

const LanguageSetting = () => {
  const { t, i18n } = useTranslation();
  const [currentLanguage, setCurrentLanguage] = useState(i18n.language || 'zh');

  useEffect(() => {
    setCurrentLanguage(i18n.language || 'zh');
  }, [i18n.language]);

  const handleChangeLanguage = async (language) => {
    // 1. 前端立即切换
    await i18n.changeLanguage(language);
    localStorage.setItem('i18nextLng', language);
    setCurrentLanguage(language);

    // 2. 保存到后端系统选项（全局、跨设备生效）
    try {
      await API.put('/api/option/', {
        key: 'Language',
        value: language,
      });
      showSuccess(t('setting.language.saved'));
    } catch (error) {
      // 即使后端保存失败，前端已经生效
      console.error('Failed to save language to backend:', error);
    }
  };

  return (
    <Card fluid style={{ borderRadius: '8px' }}>
      <Card.Content>
        <Card.Header style={{ marginBottom: '16px' }}>
          {t('setting.language.title')}
        </Card.Header>
        <p style={{ color: '#666', marginBottom: '20px' }}>
          {t('setting.language.description')}
        </p>
        <Form>
          <Form.Field>
            <label>{t('setting.language.current')}</label>
          </Form.Field>
          <Form.Group inline>
            <Form.Radio
              label={t('setting.language.options.zh')}
              name='language'
              value='zh'
              checked={currentLanguage === 'zh' || currentLanguage.startsWith('zh')}
              onChange={() => handleChangeLanguage('zh')}
              style={{ marginBottom: '8px' }}
            />
            <Form.Radio
              label={t('setting.language.options.en')}
              name='language'
              value='en'
              checked={currentLanguage === 'en' || currentLanguage.startsWith('en')}
              onChange={() => handleChangeLanguage('en')}
              style={{ marginBottom: '8px' }}
            />
          </Form.Group>
        </Form>
      </Card.Content>
    </Card>
  );
};

export default LanguageSetting;
